var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height centered-container login-form"},[_c('div',{staticClass:"text-md-center"},[_c('h1',{staticClass:"my-3 headline"},[_vm._v(" "+_vm._s(_vm.$t('views.notFound.headline'))+" ")]),_c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.goHome}},[_vm._v(" "+_vm._s(_vm.$t('views.notFound.goHome'))+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }